<template>
    <div>      
      <Head>
        <title>{{job.title}} - Jobs for Returners in Ireland</title>
        <link rel="canonical" :href="'https://backtoworkconnect.ie/job/'+job.alias" />
        <meta head-key="description" name="description" :content="job.description" />
      </Head>
      <v-container class="lighten-5" style="padding-bottom:65px">
        <BackButton></BackButton><v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        
        <v-alert
        prominent
        icon="mdi-information-outline"
        type="info"
        v-if="isExpired"
        >
            <v-row align="center">
                <v-col class="grow">
                    This job offer has expired.
                </v-col>
                <v-col class="shrink">
                    <v-btn color="primary" outlined :href="baseurl + '/search/job'">View More Jobs</v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <v-card outlined elevation="24">
           
            <v-card-title>
                <span class="text-lg-h3 text-md-h4 text-sm-h5">{{job.title}}</span>
                <template v-if="canApply() && !isExpired">
                    <v-spacer></v-spacer>
                    <v-icon v-if="!isFavorite" @click="triggerAddFavorite()" class="m-5" color="primary">mdi-heart-outline</v-icon>
                    <v-icon v-if="isFavorite" @click="triggerDelFavorite()" class="m-5" color="primary">mdi-heart</v-icon>
                    <v-btn v-if="!isApplied" @click="triggerApply()" color="primary"><v-icon>mdi-send</v-icon>Apply</v-btn>
                    <v-btn v-if="isApplied" color="secondary"><v-icon>mdi-check</v-icon>Applied</v-btn>
                </template>
            </v-card-title>
            <v-card-subtitle class="mt-5">
                <v-btn outlined color="primary" class="mr-2" v-if="job.organization.is_returner_friendly"><v-icon color="primary">mdi-home-export-outline</v-icon>Returner Friendly</v-btn>
                
                <v-btn outlined color="green" class="mr-2"  v-if="job.minimum_salary && job.maximum_salary"><v-icon color="green">mdi-currency-eur</v-icon>{{ job.minimum_salary }}-{{ job.maximum_salary }}</v-btn>
                <v-btn outlined color="green" class="mr-2" v-else-if="job.minimum_salary"><v-icon color="green">mdi-currency-eur</v-icon>{{ job.minimum_salary }}</v-btn>
                <v-btn outlined color="green" class="mr-2" v-else-if="job.maximum_salary"><v-icon color="green">mdi-currency-eur</v-icon>{{ job.maximum_salary }}</v-btn>
                <v-btn outlined color="blue" class="mr-2" v-if="job.remote_type && job.remote_type == 'Remote'"><v-icon>mdi-home</v-icon>{{ job.remote_type }}</v-btn>
                <v-btn outlined color="blue" class="mr-2" v-if="job.remote_type && job.remote_type == 'Hybrid'"><v-icon>mdi-home-city</v-icon>{{ job.remote_type }}</v-btn>
                <v-btn outlined color="blue" class="mr-2" v-if="job.remote_type && job.remote_type == 'In-person'"><v-icon>mdi-office-building</v-icon>{{ job.remote_type }}</v-btn>
                <v-btn outlined color="teal" class="mr-2" v-if="job.contract_type"><v-icon color="teal">mdi-file-sign</v-icon>{{ job.contract_type }}</v-btn>
                <v-btn outlined color="orange" class="mr-2" v-if="job.career_level"><v-icon color="orange">mdi-briefcase</v-icon>{{ job.career_level }}</v-btn>
            </v-card-subtitle>
            <v-card-text style="min-height:500px">
                <div style="width:350px;float:right" class="pa-2 hidden-md-and-down">
                    <v-card outlined elevation="24" shaped class="">
                        <v-card-title class="bottom-border-purple mb-3 text-h6">Company Information</v-card-title>
                        <v-card-subtitle class="mt-3"><span class="text-h6">{{job.organization.name}}</span></v-card-subtitle>
                        <v-card-text>
                            <v-img :src="baseurl + '/img/' + job.organization.photo_path"></v-img>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <a :href="baseurl+'/organization/'+job.organization.alias"><v-btn outlined primary>View Company Details</v-btn></a>
                        </v-card-actions>
                    </v-card>
                    <v-card outlined elevation="24" shaped class=" mt-5" v-if="courses && courses.length && 0">
                        <v-card-title class="text-lg-h6 mb-1 pb-0"><v-icon color="primary" class="mr-2">mdi-school</v-icon>Ready to upskill?</v-card-title>
                        <v-card-text class="px-1">
                            <CourseSquareCard :key="j.id" v-for="j in courses" :course="j" :auth="auth" :state="state" :baseurl="baseurl" :prevurl="prevurl" 
                                @toggleComponentLogin="toggleComponentLogin($event)">
                            </CourseSquareCard>
                        </v-card-text>
                    </v-card>
                </div>
                
                <v-container>
                    <v-row>
                        <v-col md="10" class="bottom-border-purple">
                            <span class="text-h5">Details</span>
                        </v-col>
                        <v-col lg="4" md="6" sm="12">
                            <span class="text-h6">Salary <v-icon  color="green">mdi-cash</v-icon></span>
                            <p>
                                <span v-if="job.minimum_salary && job.maximum_salary">€{{ job.minimum_salary }} - {{ job.maximum_salary }}</span>
                                <span v-else-if="job.minimum_salary">€{{ job.minimum_salary }}</span>
                                <span v-else-if="job.maximum_salary">€{{ job.maximum_salary }}</span>
                                <span v-else>Not disclosed</span>
                                <span v-if="job.salary_type"> {{job.salary_type }}</span>
                            </p>
                        </v-col>
                        <v-col lg="4" sm="12" md="6" v-if="job.minimum_experience || job.maximum_experience">
                            <span class="text-h6">Experience <v-icon color="orange">mdi-briefcase</v-icon></span>
                            <p>
                                <span v-if="job.minimum_experience && job.maximum_experience">{{ job.minimum_experience }} - {{ job.maximum_experience }} years</span>
                                <span v-else-if="job.minimum_experience">{{ job.minimum_experience }} year(s)</span>
                                <span v-else-if="job.maximum_experience">{{ job.maximum_experience }} year(s)</span>
                            </p>
                        </v-col>
                        
                        <v-col sm="12" lg="4" md="6" v-if="job.region">
                            <span class="text-lg-h6 text-md-body-1">Location <a :href="getUrl()" target="_blank"><v-icon color="teal">mdi-map</v-icon></a></span>
                            <p><span v-if="job.address">{{ job.address }}</span>&nbsp;<span v-if="job.city">{{ job.city }}</span>&nbsp;<span v-if="job.postal_code">{{ job.postal_code }}</span>&nbsp;{{job.region}}&nbsp;<a :href="getUrl()" target="_blank"><v-icon>mdi-open-in-new</v-icon></a></p>
                        </v-col>
                    </v-row>
                    <v-row v-if="job.description">
                        <v-col md="12">
                            <span class="text-h6">Description</span>
                            <p v-html="job.description"></p>
                        </v-col>
                    </v-row>
                    <v-row v-if="job.qualifications">
                        <v-col md="12">
                            <span class="text-h6">Qualifications</span>
                            <p v-html="job.qualifications"></p>
                        </v-col>
                    </v-row>
                    <v-row v-if="job.application_info">
                        <v-col md="12">
                            <span class="text-h6">Application Information</span>
                            <p v-html="job.application_info"></p>
                        </v-col>
                    </v-row>
                    <v-row v-if="job.education">
                        <v-col md="12">
                            <span class="text-h6">Education</span>
                            <p v-html="job.education"></p>
                        </v-col>
                    </v-row>
                    <v-row v-if="job.experience">
                        <v-col md="12">
                            <span class="text-h6">Experience</span>
                            <p v-html="job.experience"></p>
                        </v-col>
                    </v-row>
                    <v-row v-if="job.skills">
                        <v-col md="12">
                            <span class="text-h6">Skills</span>
                            <p v-html="job.skills"></p>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

        </v-card>
        <v-card outlined elevation="24" shaped class="hidden-lg-and-up mt-5 p-2" >
            <v-card-title class="bottom-border-purple mb-3 text-h6">Company Information</v-card-title>
            <v-card-subtitle class="mt-3"><span class="text-h6">{{job.organization.name}}</span></v-card-subtitle>
            <v-card-text>
                <v-img :src="baseurl + '/img/' + job.organization.photo_path"></v-img>
            </v-card-text>
            <v-card-actions class="justify-center">
                <a :href="baseurl+'/organization/'+job.organization.alias"><v-btn outlined primary>View Company Details</v-btn></a>
            </v-card-actions>
        </v-card>
        <v-card outlined elevation="24" shaped class=" mt-5" v-if="courses && courses.length">
            <v-card-title class="text-lg-h4 text-md-h5 text-sm-h6 mb-5">Ready to upskill?</v-card-title>
            <v-card-subtitle class="border-bottom-purple">Training courses suggestions are for guidance purposes only. Always seek professional advice from qualified career guidance counsellors.</v-card-subtitle>
            <v-card-text>
                <CourseCard :key="j.id" v-for="j in courses" :course="j" :auth="auth" :state="state" :baseurl="baseurl" :prevurl="prevurl" 
                    @toggleComponentLogin="toggleComponentLogin($event)">
                </CourseCard>
            </v-card-text>
        </v-card>   
      </v-container>
      <JobApplyDialog 
        v-if="auth.user && !isApplied" 
        :user = "auth.user" 
        :dialog="applyDialog" 
        :job="job" 
        @close="applyDialog = false" 
        :baseurl="baseurl">
        </JobApplyDialog>
      <v-app-bar class="fixedFooter"
  elevation="4"
        v-if="prevurl || !isApplied"
>
            <v-btn v-if="prevurl" :href="prevurl">Back</v-btn><v-spacer></v-spacer>
            <template v-if="canApply()">
                <v-btn @click="triggerApply()" v-if=" !isApplied" ><v-icon>mdi-plane</v-icon>Apply</v-btn>
                <v-btn v-if="isApplied" color="secondary" ><v-icon>mdi-check</v-icon>Applied</v-btn>
            </template>
        </v-app-bar>
         <v-snackbar
         
            
        v-if="!isExpired"
            v-model="snackbar"
            :timeout="timeout"
            color="#560354"
            bottom
            right
            dark
            
          >
            <div class="d-flex align-center">
    <v-icon class="mr-2" size="64">mdi-fire</v-icon>
    <span style="font-size: 24px;line-height: 32px;">{{ motivationalMessage }}</span>
  </div>
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
    </div>
</template>
<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import JobApplyDialog from '@/Shared/JobApplyDialog'
  import axios from 'axios'
  
  import BackButton from '@/Shared/BackButton'
  import CourseCard from '@/Shared/CourseCard'
  import CourseSquareCard from '@/Shared/CourseSquareCard'

  export default {
    props: {
    
      job: Object,
      auth: Object,
      state: String,
      isExpired: Boolean,
      isFavorite: Boolean,
      isApplied: Boolean,
      baseurl: String,
      prevurl: String,
      courses: Array,
    },
    components: {
      Head,
      JobApplyDialog,
      CourseCard,
      BackButton,
      CourseSquareCard
    },
    layout: Layout,
    data() {
        return {
            applyDialog: false,
            breadcrumbs: [
                {
                    text: 'Home',
                    disabled: false,
                    href: this.baseurl,
                },
                {
                    text: this.job.category.title,
                    disabled: false,
                    href: this.baseurl + '/job/'+this.job.category.alias,
                },
                {
                    text: 'View',
                    disabled: true,
                    href: '',
                },
            ],
            
             snackbar: false,
      timeout: 100000,
      motivationalMessages: [
        'You\'ve already done harder things. Hit the Apply Now button!',
        'A career break doesn\'t break your career—it gives you perspective. Hit the Apply Now button!',
        'Every expert was once a beginner. Hit the Apply Now button!',
        'The best time to restart was yesterday. The next best time is now.',
        'Returners bring wisdom, resilience, and life skills no course can teach. Hit the Apply Now button!',
        'Your career break is your superpower, not a setback. Hit the Apply Now button!',
        'A small action—like clicking apply—can change the course of your life. Hit the Apply Now button!',
        'Courage doesn\'t roar. Sometimes, it\'s just clicking \'Apply Now\'.',
        'Stop wondering \'What if?\' and start discovering \'What\'s next?\' Hit the Apply Now button!',
        'The job you\'re thinking about could be the job that changes everything. Hit the Apply Now button!',
        'Returners often question their worth—but employers are searching for exactly what you bring. Hit the Apply Now button!',
        'You don\'t need to be perfect. You just need to begin. Hit the Apply Now button!',
        'You\'re not too old. You\'re not too out of touch. You\'re exactly what someone\'s looking for. Hit the Apply Now button!'
      ],
      motivationalMessage: ''
        }
    },
    mounted() {
        console.log('job view mounted',this.hasShownMessageToday());
        if (!this.hasShownMessageToday()) {
            setTimeout(() => {
            this.showMotivationalMessage();
            }, 5000);
        }
  },
    watch: {
    },
    created() {
    },
    methods: {
         hasShownMessageToday() {
            return this.getCookie('motivationalMessageShown') === 'true';
        },
        showMotivationalMessage() {
      const randomIndex = Math.floor(Math.random() * this.motivationalMessages.length);
      this.motivationalMessage = this.motivationalMessages[randomIndex];
            this.setCookie('motivationalMessageShown', 'true', 1); // Expires in 1 day
            console.log('showing motivational message',this.motivationalMessage);
      this.snackbar = true;
    },
    getCookie(name) {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        return parts.length !== 2 ?
        undefined :
        parts.pop().split(';').shift()
    },
    setCookie(name, value, expiryDays, domain, path) {
        const exdate = new Date()
        exdate.setDate(exdate.getDate() + (expiryDays || 365))
        const cookie = [
        `${name}=${value}`,
        `expires=${exdate.toUTCString()}`,
        `path=${(path || '/')}`
        ]
        if (domain) {
        cookie.push(`domain=${domain}`)
        }
        document.cookie = cookie.join(';')
    },
        isValidHttpUrl(string) {
            let url;
            
            try {
            url = new URL(string);
            } catch (_) {
            return false;  
            }

            return url.protocol === "http:" || url.protocol === "https:";
        },
        toggleComponentLogin(e) {
            console.log('results triggering login',e)
            if (!this.auth.user)
                this.$parent.$emit('toggleComponentLogin',e);
        
        },
        canApply() {
            if (!this.auth.user || (this.auth.user.roles.includes('admin') || this.auth.user.roles.includes('user')))
                return true;
            else
                return false;
        },
        getUrl() {
            return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(this.job.address +','+this.job.region)

        },
      triggerApply() {
        console.log('trigger apply');
        /*if (!this.auth.user)
            this.$parent.$emit('toggleComponentLogin','jobapply-'+this.job.id);*/
        /*else if (this.job.job_link)
            window.open(window.location + '/apply')
        else
            this.applyDialog = true;*/

        /*if (this.isValidHttpUrl(this.job.job_link))
          window.open(this.baseurl+'/job/'+this.job.alias+'/apply'); //window.open(window.location + '/apply');
        else
          window.open("mailto:"+this.job.job_link)*/

        if (this.job.ext_site || 1)
        {
            console.log('login required')
          if (!this.auth.user)
            this.$parent.$emit('toggleComponentLogin','jobapply-'+this.job.id)
          else if (this.isValidHttpUrl(this.job.job_link))
            window.open(this.baseurl+'/job/'+this.job.alias+'/apply');
          else
          {
            this.$inertia.get(this.baseurl+'/job/'+this.job.alias+'/eapply');

            window.open("mailto:"+this.job.job_link)
          }
        }
        else
        {
            console.log('no login required')
          if (this.isValidHttpUrl(this.job.job_link))
            window.open(this.baseurl+'/job/'+this.job.alias+'/apply');
          else {

            window.open("mailto:"+this.job.job_link)
          }
        }
            
      },
      triggerAddFavorite() {
        console.log('trigger addfavorite');
        if (!this.auth.user)
            this.$parent.$emit('toggleComponentLogin','jobaddfavorite-'+this.job.id);
        else
            this.$inertia.get(this.baseurl+"/user/job/addfavorite/"+this.job.id)
      },
      triggerDelFavorite() {
        console.log('trigger delfavorite',this.auth.user,this.baseurl+"/user/job/delfavorite/"+this.job.id);
        if (!this.auth.user)
          this.$parent.$emit('toggleComponentLogin','jobdelfavorite-'+this.job.id);
        else
            this.$inertia.get(this.baseurl+"/user/job/delfavorite/"+this.job.id);
      }
    },
  }
  </script>
  
  <style>
    .fixedFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }
    .v-snack__wrapper {
  min-width: 400px !important;
  max-width: 600px !important;
}

.v-snack__content {
  font-size: 16px !important;
  padding: 16px !important;
}

.v-snack__action {
  margin-left: 12px !important;
}
    </style>